import { useState, useEffect } from 'react'
import PaymentsRequestsTable from '../../../../components/bankAccount/paymentRequests/PaymentsRequestsTable'
import Box from '@mui/material/Box'
import theme from '../../../../helpers/theme'
import FormattedTabs from '../../../../components/generic/formattedTabs'
import { backendGetRequest } from '../../../../helpers/callBackend'
import HeaderBox from '../../../../components/generic/arpariBoxes/headerBox'
import Stack from '@mui/material/Stack'
import checkFlag from '../../../../helpers/featureFlags'
import ComingSoonTab from '../sendFundsDwolla/ComingSoonTab'

const PendingRequests = () => {
  const [paymentRequests, setPaymentRequests] = useState([])
  const [totalRecords, setTotalRecords] = useState(-1)
  const [loading, setLoading] = useState(false)
  const [canceledRequests, setCanceledRequests] = useState([])
  const [liveRequests, setLiveRequests] = useState([])
  const [awaitingApproval, setAwaitingApproval] = useState([])

  const getPrPage = async (pageNum) => {
    try {
      const prResp = await backendGetRequest('/api/payments/payment-request', {
        params: {
          all: true,
          page_index: pageNum,
        },
      })
      const paymentRequestArray = prResp.data?.data
      setPaymentRequests((prevState) => [...prevState, ...paymentRequestArray])
    } catch (error) {
      // error getting payment request objects
      return
    }
  }

  const getPaymentRequests = async () => {
    setPaymentRequests([])
    setLoading(true)
    let totalPages = 0
    try {
      const paginationResp = await backendGetRequest('/api/payments/payment-request', {
        params: {
          all: true,
          page_index: 0,
        },
      })
      totalPages = paginationResp.data?.total_pages
      setTotalRecords(paginationResp.data?.total_records)

    } catch (error) {
      // error while getting pagination info
      return
    }

    for (let pageNum = 1; pageNum < totalPages + 1; pageNum++) {
      getPrPage(pageNum)
    }
  }

  const updatePaymentRequests = (paymentRequest, method) => {
    // edit payment requests data displayed to user
    if (!paymentRequest) {
      return
    }
    let newPaymentReqs = [...paymentRequests]
    switch (method) {
      case 'add':
        newPaymentReqs.push(paymentRequest)
        break
      case 'replace':
        // approving a new payment request
        newPaymentReqs = paymentRequests.map((currentPr) => {
          if (currentPr.id === paymentRequest.id) {
            return paymentRequest
          }
          return currentPr
        })
        break
      case 'remove':
        // in this page, cancelling should actually just update the set of
        // all payment reqs
        newPaymentReqs = paymentRequests.map((currentPr) => {
          if (currentPr.id === paymentRequest.id) {
            return paymentRequest
          }
          return currentPr
        })
        break
    }
    setPaymentRequests(newPaymentReqs)
  }

  useEffect(() => {
    if (!checkFlag('paymentsV2')) {
      return
    }
    getPaymentRequests()
  }, [])

  useEffect(() => {
    let newPaymentReqs = [...paymentRequests]
    let newCanceled = []
    let newLive = []
    let newPending = []

    newPaymentReqs.forEach((paymentRequest) => {
      if (paymentRequest.is_canceled) {
        newCanceled.push(paymentRequest)
      } else if (paymentRequest.dwolla_payment_id) {
        if (paymentRequest.transfer_object.status == 'failed') {
          newPending.push(paymentRequest)
        } else {
          newLive.push(paymentRequest)
        }
      } else {
        newPending.push(paymentRequest)
      }
    })
    setAwaitingApproval(newPending)
    setLiveRequests(newLive)
    setCanceledRequests(newCanceled)

    // checks if we have pulled all prs yet
    if (!loading) {
      return
    }
    if (totalRecords >= 0 && paymentRequests.length == totalRecords) {
      setLoading(false)
    }
  }, [paymentRequests])

  const tabPanes = !checkFlag('paymentsV2')
    ? [
      {
        title: 'Requests',
        key: 0,
        body: <ComingSoonTab title='Pending Requests' config='paymentReqs' />,
      },
      {
        title: 'Sent',
        key: 1,
        body: <ComingSoonTab title='Live Payments' config='paymentReqs' />,
      },
      {
        title: 'Canceled & Returned',
        key: 2,
        body: <ComingSoonTab title='Canceled & Returned' config='paymentReqs' />,
      },
    ]
    : [
      {
        title: 'Requests',
        key: 0,
        body: (
          <Stack spacing={1}>
            <HeaderBox title='Pending Requests' />
            <PaymentsRequestsTable
              paymentRequests={awaitingApproval}
              loading={loading}
              updatePaymentRequests={updatePaymentRequests}
            />
          </Stack>
        ),
      },
      {
        title: 'Sent',
        key: 1,
        body: (
          <Stack spacing={1}>
            <HeaderBox title='Sent' />
            <PaymentsRequestsTable
              paymentRequests={liveRequests}
              loading={loading}
              updatePaymentRequests={updatePaymentRequests}
            />
          </Stack>
        ),
      },
      {
        title: 'Canceled & Returned',
        key: 2,
        body: (
          <Stack spacing={1}>
            <HeaderBox title='Canceled & Returned Payments' />
            <PaymentsRequestsTable
              paymentRequests={canceledRequests}
              loading={loading}
              updatePaymentRequests={updatePaymentRequests}
            />
          </Stack>
        ),
      },
    ]

  return (
    <Box
      sx={{
        overflow: 'auto',
        maxHeight: '99%',
      }}
    >
      <Box sx={{ margin: theme.dashboard.margins }}>
        <FormattedTabs defaultActiveKey={0} tabPanes={tabPanes} />
      </Box>
    </Box>
  )
}

export default PendingRequests
